(function(){
  // Fast peel speed you liked
  const FRAME_MS = 40;

  const SWIPE_THRESHOLD_PX = 40; // how far you have to drag to count as a swipe

  const sections = document.querySelectorAll('.cmi-section');
  if(!sections.length) return;

  sections.forEach(initSection);

  function initSection(sectionEl){
    const sectionId     = sectionEl.dataset.sectionId;
    const baseUrl       = sectionEl.dataset.baseUrl; // ends with Anim_
    const totalFrames   = parseInt(sectionEl.dataset.totalFrames,10) || 73;

    const STEP_TARGET_FRAMES = {
      1: parseInt(sectionEl.dataset.frameStep1,10) || 21,
      2: parseInt(sectionEl.dataset.frameStep2,10) || 52,
      3: parseInt(sectionEl.dataset.frameStep3,10) || 72
    };

    const initialStart  = parseInt(sectionEl.dataset.initialStartFrame,10) || 0;  // e.g. 0
    const initialEnd    = parseInt(sectionEl.dataset.initialEndFrame,10)   || 21; // e.g. 21

    // DOM refs
    const stepButtons   = Array.from(sectionEl.querySelectorAll('.cmi-step'));
    const descBlocks    = Array.from(sectionEl.querySelectorAll('.cmi-desc'));
    const stackEl       = sectionEl.querySelector('[data-stack]'); // animation frames container

    // Frame <img> layers
    let frameEls        = [];
    // Track peeled state: true = hidden/peeled
    let hiddenMap       = [];

    // State
    let currentFrameIdx = initialStart; // start at 0
    let currentStep     = 3;            // start "virtually" at 3 so first wave is 3→1
    let introHasPlayed  = false;
    let isAnimating     = false;

    buildStack();
    preloadFrames();
    initializeVisibility();

    /* ----------------- CLICK HANDLERS FOR STEPS ----------------- */

    stepButtons.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const targetStep = parseInt(btn.dataset.step,10);
        goToStep(targetStep);
      });
    });

    function goToStep(targetStep){
      if(isAnimating || targetStep === currentStep) return;

      const targetFrame = STEP_TARGET_FRAMES[targetStep] ?? currentFrameIdx;

      // 1. Immediate UI intent (pre-active state + copy swap)
      applyStepStateImmediately(targetStep);

      // 2. Run wave + peel as motion only
      runMotionOnly(currentStep, targetStep, currentFrameIdx, targetFrame);

      // 3. Logically we're now on that step
      currentStep = targetStep;
    }

    /* ----------------- INITIAL SCROLL REVEAL ----------------- */

    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting && entry.intersectionRatio >= 0.5){
          if(!introHasPlayed){
            introHasPlayed = true;

            const targetStep  = 1;
            const targetFrame = initialEnd; // 21

            applyStepStateImmediately(targetStep);
            runMotionOnly(currentStep, targetStep, currentFrameIdx, targetFrame);
            currentStep = targetStep;
          }
        }
      });
    }, { root:null, threshold:[0,0.5,1]});
    io.observe(sectionEl);

    /* ----------------- SWIPE HANDLING (NEW) ----------------- */

    // We want swipe to work anywhere in the whole section now,
    // not just on the tumbler.
    let pointerDownX = null;
    let pointerDownY = null;
    let pointerActive = false;

    // touch events
    sectionEl.addEventListener('touchstart', handlePointerDown, {passive:true});
    sectionEl.addEventListener('touchend', handlePointerUp, {passive:true});

    // mouse events (desktop drag)
    sectionEl.addEventListener('mousedown', handlePointerDown);
    sectionEl.addEventListener('mouseup', handlePointerUp);

    function handlePointerDown(e){
      // if we're mid-animation, ignore swipe start
      if(isAnimating) return;

      pointerActive = true;

      if(e.touches && e.touches[0]){
        pointerDownX = e.touches[0].clientX;
        pointerDownY = e.touches[0].clientY;
      } else {
        pointerDownX = e.clientX;
        pointerDownY = e.clientY;
      }
    }

    function handlePointerUp(e){
      if(!pointerActive) return;
      pointerActive = false;

      if(isAnimating) return;

      let upX, upY;
      if(e.changedTouches && e.changedTouches[0]){
        upX = e.changedTouches[0].clientX;
        upY = e.changedTouches[0].clientY;
      } else {
        upX = e.clientX;
        upY = e.clientY;
      }

      const dx = upX - pointerDownX;
      const dy = upY - pointerDownY;

      // We only care about mostly-horizontal swipes,
      // and only if they clear the threshold in px.
      const absDX = Math.abs(dx);
      const absDY = Math.abs(dy);

      if(absDX < SWIPE_THRESHOLD_PX) return;
      if(absDY > absDX) return; // mostly vertical, ignore

      // Swipe left -> go forward (next step)
      // Swipe right -> go backward (prev step)
      if(dx < 0){
        // left swipe, advance step
        goToRelativeStep(+1);
      }else{
        // right swipe, previous step
        goToRelativeStep(-1);
      }
    }

    function goToRelativeStep(direction){
      // direction +1 = next (1->2->3), -1 = prev (3->2->1)
      // Wrap or clamp? Your UI doesn't wrap right now,
      // so we'll clamp between 1 and 3.
      let targetStep = currentStep + direction;
      if(targetStep < 1) targetStep = 1;
      if(targetStep > 3) targetStep = 3;
      goToStep(targetStep);
    }

    /* ----------------- STACK SETUP ----------------- */

    function buildStack(){
      const baseZ = 1000;
      for(let i=0; i<totalFrames; i++){
        const img = document.createElement('img');
        img.setAttribute('draggable','false');
        img.setAttribute('alt','');
        img.setAttribute('decoding','async');

        img.style.zIndex = (baseZ - i).toString();

        frameEls[i] = img;
        stackEl.appendChild(img);
      }
    }

    function preloadFrames(){
      for(let i=0; i<totalFrames; i++){
        const p = pad3(i);
        frameEls[i].src = baseUrl + p + '.webp';
        hiddenMap[i] = false; // visible initially
      }
    }

    function pad3(n){
      return String(n).padStart(3,'0');
    }

    function initializeVisibility(){
      currentFrameIdx = initialStart; // 0
    }

    /* ----------------- FRAME PEELING ----------------- */

    function hideFrame(idx){
      if(!hiddenMap[idx]){
        frameEls[idx].classList.add('is-hidden');
        hiddenMap[idx] = true;
      }
    }

    function showFrame(idx){
      if(hiddenMap[idx]){
        frameEls[idx].classList.remove('is-hidden');
        hiddenMap[idx] = false;
      }
    }

    // Peel animation only (visual flourish).
    function peelToFrame(startIdx, endIdx, done){
      if(startIdx === endIdx){
        if(typeof done==="function") done();
        return;
      }

      let dir = (endIdx > startIdx) ? 1 : -1;
      let current = startIdx;
      let lastTick = performance.now();

      function step(now){
        const elapsed = now - lastTick;
        if(elapsed >= FRAME_MS){
          lastTick = now;

          const next = current + dir;

          if(dir > 0){
            // forward: peel off the layer we're leaving
            hideFrame(current);
          }else{
            // backward: rebuild the layer we're stepping back onto
            showFrame(next);
          }

          current = next;
          currentFrameIdx = current;

          if(current === endIdx){
            if(typeof done==="function") done();
            return;
          }
        }

        requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    /* ----------------- WAVE ANIMATION ----------------- */

    // We adjust waveTravel so that when it reaches the final
    // target step, that step upgrades from .is-preactive → .is-active.
    function waveTravel(fromStep, toStep){
      const dir = (toStep > fromStep) ? 1 : -1;
      let hop   = fromStep;
      let totalDelay = 0;

      while(hop !== toStep){
        const nextHop = hop + dir;
        const dotsKey = hop < nextHop ? (hop + '-' + nextHop) : (nextHop + '-' + hop);

        const dotsGroup = sectionEl.querySelector('.cmi-dots[data-between="' + dotsKey + '"]');
        const nextBtn   = sectionEl.querySelector('.cmi-step[data-step="' + nextHop + '"]');

        if(dotsGroup){
          const dotElsRaw = Array.from(dotsGroup.querySelectorAll('.cmi-dot'));
          const dotSeq = (dir > 0) ? dotElsRaw : dotElsRaw.slice().reverse();

          dotSeq.forEach((dotEl, idx)=>{
            scheduleWave(dotEl, "dot", totalDelay + idx*120);
          });

          if(nextBtn){
            const afterDots = totalDelay + dotSeq.length*120;

            // bump number; if it's the final target, also promote it
            scheduleWaveNumber(nextBtn, nextHop === toStep, afterDots);

            totalDelay = afterDots + 200;
          }else{
            totalDelay += dotSeq.length*120 + 200;
          }
        }else{
          if(nextBtn){
            scheduleWaveNumber(nextBtn, nextHop === toStep, totalDelay);
          }
          totalDelay += 200;
        }

        hop = nextHop;
      }
    }

    // scheduleWave for dots
    function scheduleWave(el, kind, delayMs){
      setTimeout(()=>{
        triggerWave(el, kind);
      }, delayMs);
    }

    // scheduleWaveNumber:
    // - bump the number visually
    // - if it's the FINAL target, upgrade it to .is-active
    function scheduleWaveNumber(btnEl, isFinalTarget, delayMs){
      setTimeout(()=>{
        if(isFinalTarget){
          promoteStepToActive(btnEl);
        }
        triggerWave(btnEl, "num");
      }, delayMs);
    }

    function triggerWave(el, kind){
      const waveClass = (kind === "dot") ? "cmi-wave-dot" : "cmi-wave-num";

      el.classList.remove(waveClass);
      // force reflow so animation restarts
      // eslint-disable-next-line no-unused-expressions
      el.offsetHeight;
      el.classList.add(waveClass);

      setTimeout(()=>{
        el.classList.remove(waveClass);
      }, 250);
    }

    /* ----------------- ACTIVE STATE HANDLING ----------------- */

    // Called immediately on click / swipe / first reveal.
    // Puts the chosen step into "pre-active" and swaps text copy instantly.
    function applyStepStateImmediately(stepNum){
      stepButtons.forEach(btn=>{
        const s = parseInt(btn.dataset.step,10);

        // Clear both classes first
        btn.classList.remove('is-active');
        btn.classList.remove('is-preactive');

        if(s === stepNum){
          // Give this one pre-active, NOT full active yet
          btn.classList.add('is-preactive');
          btn.setAttribute('aria-selected','true');
        }else{
          btn.setAttribute('aria-selected','false');
        }
      });

      // Copy blocks update instantly
      descBlocks.forEach(block=>{
        const s = parseInt(block.dataset.stepDesc,10);
        if(s === stepNum){
          block.classList.add('is-active');
          block.hidden = false;
        }else{
          block.classList.remove('is-active');
          block.hidden = true;
        }
      });
    }

    // When the wave reaches the final clicked/swiped step,
    // we upgrade that step from is-preactive → is-active.
    function promoteStepToActive(btnEl){
      stepButtons.forEach(b=>{
        b.classList.remove('is-active');
        b.classList.remove('is-preactive');
      });

      btnEl.classList.add('is-active');
    }

    /* ----------------- MOTION ORCHESTRATOR ----------------- */

    // Kick off visual animations only.
    // We don't delay text anymore; text is immediate.
    function runMotionOnly(fromStep, toStep, fromFrame, toFrame){
      isAnimating = true;

      // Launch wave (which will also eventually promote final to .is-active)
      waveTravel(fromStep, toStep);

      // Launch peel toward that frame
      peelToFrame(fromFrame, toFrame, ()=>{
        currentFrameIdx = toFrame;
        isAnimating = false;
      });
    }
  }
})();
